import React, { useState, useEffect } from 'react';
import { reduxForm } from 'redux-form';
import { Modal } from 'angieslist-react-components';
import { isEmpty } from 'lodash';
import { tracker } from 'angieslist-app-platform';
import EditImageForm from './EditImageForm';

type Props = {
  imagesToEdit: Object,
  serviceProviderId: String | Number,
  updateShowcaseMedia: (refetchShowcase: Boolean, values: Object) => void,
  updateShowcaseMediaError: Object,
  updateShowcaseMediaReset: () => void,
  updateShowcaseMediaIsLoading: Boolean,
  saveMediaReset: () => void,
  updateShowcaseMediaResponse: Object,
  rotationEnabled: Boolean,
};

const EditMultipleImagesModal = ({
  imagesToEdit,
  serviceProviderId,
  updateShowcaseMedia,
  updateShowcaseMediaError,
  updateShowcaseMediaReset,
  updateShowcaseMediaIsLoading,
  updateShowcaseMediaResponse,
  saveMediaReset,
  rotationEnabled,
}: Props) => {
  const [show, setShow] = useState(false);

  const handleShow = () => setShow(true);

  const handleClose = () => {
    tracker.track('Item Clicked', {
      activityLocation: 'Edit Image Modal',
      description: 'Cancel',
      serviceProviderId,
    });
    setShow(false);
    // Resetting here is vital so when a user cancels Redux doesn't hold the state, also
    // when user submits it only submits the changed field
    updateShowcaseMediaReset();
    saveMediaReset();
  };

  useEffect(() => {
    if (!isEmpty(imagesToEdit)) {
      handleShow();
    }
  });

  return (
    <span>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        className="Edit-Multiple-Images-Modal--Container"
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Images</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <EditImageForm
            imagesToEdit={imagesToEdit}
            handleClose={handleClose}
            updateShowcaseMedia={updateShowcaseMedia}
            updateShowcaseMediaError={updateShowcaseMediaError}
            updateShowcaseMediaReset={updateShowcaseMediaReset}
            updateShowcaseMediaIsLoading={updateShowcaseMediaIsLoading}
            updateShowcaseMediaResponse={updateShowcaseMediaResponse}
            saveMediaReset={saveMediaReset}
            rotationEnabled={rotationEnabled}
          />
        </Modal.Body>
      </Modal>
    </span>
  );
};

export default (
  reduxForm({
    form: 'EditMultipleImagesForm',
  }))(EditMultipleImagesModal);



// WEBPACK FOOTER //
// ./src/modules/showcase/browser/components/EditMultipleImagesModal.js